import React from 'react';
import {Navigate, Outlet} from "react-router";
import Layout from "../layout/Layout";

const ALLOWED = new Set(["Administrator", "Owner"]);

const AdministratorRoute = () => {
    const role = localStorage.getItem("role");

    if (!ALLOWED.has(role)) {
        return <Navigate to="/unauthorized"/>;
    }

    return (
        <Layout>
            <Outlet/>
        </Layout>
    );
};

export default AdministratorRoute;